$(function () {
	var www = $(window).width();
	var hhh = $(window).height();
	var preTop;

	/*-------------------------------------
SCROLL
-------------------------------------*/

	$(window).on("resize", adjustScroll);

	//scroll
	var scrollTimer;
	$(window).bind("scroll touchmove", function () {
		clearInterval(scrollTimer);
		scrollTimer = setInterval(function () {
			adjustScroll();
			clearInterval(scrollTimer);
		}, 10);
	});
	//adjustScroll();

	var preDocViewTop = 0;
	var docViewTop = 0;

	function adjustScroll() {
		docViewTop = $(window).scrollTop();
		var hhh = $(window).height();

		www = $(window).width();

		//console.log(docViewTop);
		//console.log(preDocViewTop);

		//if (docViewTop > preDocViewTop && docViewTop > 60) {
		if (docViewTop > hhh*1) {
			$("#boyBtnBottom").addClass("show");
		} else {
			$("#boyBtnBottom").removeClass("show");
		}

		preDocViewTop = docViewTop;
	}

	/*-------------------------------------
MENU
-------------------------------------*/

	// $("#button_container").click(function () {
	// 	$("html,body").toggleClass("hiddenBox");
	// 	$("#toggle").toggleClass("active");
	// 	$("#overlay").toggleClass("open");
	// });

	// $("#overlay ul li a").click(function () {
	// 	$("#toggle").removeClass("active");
	// 	$("#overlay").removeClass("open");
	// });

	/*-------------------------------------
RESIZE
-------------------------------------*/

	$(window).on("resize", adjustResize);

	function adjustResize() {
		www = $(window).width();
		hhh = $(window).height();
	}
	adjustResize();

	/*-------------------------------------
POPUP
-------------------------------------*/

	var preTop;
	var www;

	www = $(window).width();

	var args = {
		delegate: "a.popup",
		type: "inline",
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: "mfp-img-mobile mfp-fade",
		closeOnBgClick: true,
		removalDelay: 300,

		gallery: {
			enabled: true,
		},
		callbacks: {
			open: function () {
				preTop = $(window).scrollTop();
				$("html,body").addClass("hiddenBox");
				setTimeout(function () {
					$("html,body").addClass("hiddenBox");
				}, 100);

				$("html, body").animate({ scrollTop: preTop }, 0, "swing");

				setTimeout(function () {
					$(window).on("resize", adjustResize);
				}, 300);
			},
			beforeClose: function () {
				//$("html, body").animate({scrollTop:preTop}, 0, "swing");
			},
			close: function () {
				$("html,body").removeClass("hiddenBox");

				//$("html, body").animate({scrollTop:preTop}, 0, "swing");

				$(window).trigger("resize");
			},

			change: function () {},
		},
	};

	//$('#tokyo').magnificPopup(args);

	/*-------------------------------------
WAYPOINT
-------------------------------------*/

	www = $(window).width();

	if (www > 719) {
		var ppp = "80%";
	} else {
		var ppp = "80%";
	}

	$(".pointList li").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeSimple").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fade").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".fadeRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskRight").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskLeft").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskTop").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	$(".maskBottom").waypoint(
		function (direction) {
			var activePoint = $(this.element);
			if (direction === "down") {
				activePoint.addClass("active");
			} else {
				//activePoint.removeClass('active');
			}
		},
		{ offset: ppp },
	);

	/*-------------------------------------
COMMON
-------------------------------------*/

	function commonEvent() {
		adjustResize();

		$("a.scroll").click(function () {
			//$.magnificPopup.close();

			var speed = 500;
			var href = $(this).attr("href");
			if (href == "#" || href == "") {
				var target = "html";
			} else {
				var target = $(href);

				www = $(window).width();
				var sa = 0;

				if (www > 980) {
					sa = 0;
				} else {
					sa = 0;
				}

				var position = target.offset().top - sa;

				hideFlg = false;
				$("header").addClass("hide");

				$("html, body").animate({ scrollTop: position }, speed, "swing");

				setTimeout(function () {
					hideFlg = true;
				}, 600);

				return false;
			}
		});

		var topBtn = $("#pagetop");

		//スクロールしてトップ
		topBtn.click(function () {
			$("body,html").animate(
				{
					scrollTop: 0,
				},
				500,
			);
			return false;
		});
	}
	commonEvent();
});
